import { boundaryWKT2Bounds } from "@/carto-node/models/visualization"

const MAP_TYPE="MapItem"
export function setFetchingState(state) {
  state.isFetching = true;
  state.isErrored = false;
  state.error = {};
}

export function setFilterType(state, filterType = "mine") {
  state.filterType = filterType;
}
export function setFilterKeyword(state, filterKeyword = "") {
  state.filterKeyword = filterKeyword;
}
export function setPagination(state, page = 1) {
  state.page = page;
  state.numPages =
    Math.ceil(state.metadata.total_entries / state.resultsPerPage) || 1;
}
export function setOrder(DEFAULT_VALUES) {
  return function (state, orderOptions) {
    state.order = orderOptions.order || DEFAULT_VALUES.order;
    state.orderDirection =
      orderOptions.direction || DEFAULT_VALUES.orderDirection;
  };
}

export function setResultsPerPage(state, resultsPerPage = 12) {
  state.resultsPerPage = resultsPerPage;
}

export function setQueryFilter(state, query) {
  state.queryFilter = query;
}

export function setRequestError(state, error) {
  state.isFetching = false;
  state.isErrored = true;
  state.error = error;
}

export function setLayers(state, layersData) {
  const existIds = state.addedList.map(m => m.uid)
  state.list = layersData.data.list.map(m => ({ 
    ...m, 
    added_to_map: existIds.includes(m.uid), 
    visible: true,
    legend: (m.fields || []).find(f => f.fieldName === 'legend')?.description,
    bounds: boundaryWKT2Bounds(m.boundaryWKT)
  }))
  state.metadata = {
    total_entries: layersData.data.total,
  };
  state.isFetching = false;
}
export function updateVisualization(
  state,
  { visualizationId, visualizationAttributes }
) {
  const vis = state.list.find((vis) => vis.id === visualizationId);

  if (vis) {
    Object.assign(vis, visualizationAttributes);
  }
}
//发布图层到球
export function addToEarth(state, mapId) {
  const map = state.list.find(m => m.id === mapId)
  if (map) {
    const cloneMap = JSON.parse(JSON.stringify(map))
    cloneMap.addedTime = Date.now()
    cloneMap.mapType = MAP_TYPE 
    state.addedList.push(cloneMap)
  }
}

//删除图层
export function removeFromEarth(state, mapId) {
  const idx = state.addedList.findIndex(m => m.id === mapId)
  if (idx >= 0) {
    state.addedList.splice(idx,1)
  }
}
